import { render, staticRenderFns } from "./SQuesFifty.vue?vue&type=template&id=a50bb8ac&"
import script from "./SQuesFifty.vue?vue&type=script&lang=js&"
export * from "./SQuesFifty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports